import React from 'react';
import { IconButton, Tooltip } from "@mui/material"
import { useUser } from '../../features';


const StyledIconButton = (props) => {
      const { hasPermission } = useUser();
      const [showBtn, setShowBtn] = React.useState(true);

      React.useState(() => {
            if(props.actionName) {
                  setShowBtn(hasPermission(props.actionName));
            } else {
                  setShowBtn(true);
            }
      }, [props.actionName]);

      return (
            showBtn ? (
                  <Tooltip title={props.label} arrow placement="top" followCursor>
                        <IconButton
                              {...props}
                              aria-label={'icon_button_lbl_' + props.label}
                              sx={{ ...(props.sx ?? {}), opacity: props.disabled ? 0.5 : 1 }}
                              onClick={props.onClick} >
                              {props.children}
                        </IconButton>
                  </Tooltip>
            )
            : null
      )
}

export default StyledIconButton;